// extracted by mini-css-extract-plugin
export default {"main":"elemLeaderboard_main__RhwVz","container":"elemLeaderboard_container__YeAr6","title":"elemLeaderboard_title__pH-35","buttonArea":"elemLeaderboard_buttonArea__TjkIM"};